import { RepFinder } from "./reps/views/rep-finder";
import { Rep } from "./reps/model/rep";
import { RepSearch } from "./reps/model/search";


var repLib, repFinder;
(function($){

    repLib = new Backbone.Collection({model: Rep});
	$(document).ready(function(){
        $.get( site_data.api_url_base + 'gr-chair/v1/rep-listing', {}, function( response ){
            // start our app here
            // console.log( response );
            repLib.add( response );
            var repSearch = new RepSearch();
            repFinder = new RepFinder({ collection : repLib, model: repSearch });
            repFinder.render();
        } );
    });
})(jQuery);